const PAYMENT_METHODS = {
  CASH_ON_DELIVERY: "cod",
  CARD: "card",
  WALLET: "wallet",
};

export default PAYMENT_METHODS;
